<template>
  <div class="">
    <el-form :model="formDocument" :rules="rules" ref="formDocument">
      <TopBarTitleComponent title="Nueva Factura" :showBackIcon="true">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
          </div>
        </template>
      </TopBarTitleComponent>
      <b-container fluid class="pb-4 px-lg-4 pt-4">
        <b-row>
          <b-col>
            <div class="card box-shadow">
              <div class="card-body">
                <b-row>
                  <b-col xs="12" sm="12" md="12">
                    <b-row>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="user_business_client_id">
                          <SelectBusinessComponent
                            @onChangeSelect="onChangeSelectBusiness"
                          />
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="email">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Correo</label>
                          </slot>
                          <el-input
                            type="text"
                            placeholder=""
                            class=""
                            v-model="formDocument.email"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="user_business_e_point_id">
                          <SelectEmissionPointsComponent
                            @onChangeSelect="onChangeSelectEmissionPoints"
                            :setEmissionPointId="
                              formDocument.user_business_e_point_id
                            "
                            :disabled="hasProducts"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xs="12" sm="12" md="4">
                        <InputDatePickerComponent
                          @onChangeDatePicker="onChangeDatePicker"
                          prop="emission_date"
                          placeholder=""
                          title="Fecha de emisión"
                          :isDisabledDate="true"
                          :setDate="formDocument.emission_date"
                        />
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item prop="sri_forms_payment_id">
                          <slot name="label">
                            <label class="font-semi-bold m-0">
                              Formas de pago
                            </label>
                          </slot>
                          <SelectSriFormsPaymentsComponent
                            @onChangeSelect="onChangeSriFormsPaymentsSelect"
                            :setSriFormsPaymentId="
                              formDocument.sri_forms_payment_id
                            "
                          />
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="4">
                        <el-form-item style="margin-top:0">
                          <slot name="label">
                            <label class="font-semi-bold m-0"
                              >Proyecto (opcional)</label
                            >
                          </slot>
                          <el-select
                            v-model="formDocument.project_id"
                            placeholder="Sin proyecto"
                            clearable
                            filterable
                            style="width:100%"
                          >
                            <el-option
                              v-for="proj in filteredProjects"
                              :key="proj.id"
                              :label="proj.name"
                              :value="proj.id"
                            />
                          </el-select>
                          <small
                            style="color:#888;margin-top:4px;display:block;font-size:11px"
                          >
                            <a
                              @click="$router.push({ name: 'projects' })"
                              style="color:#3ecfb4;cursor:pointer"
                              >+ Crear nuevo proyecto</a
                            >
                          </small>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <TableInputProducts
                  @onToogleProducts="onToogleProducts"
                  :setProducts="formDocument.products"
                  :setEmissionPointId="formDocument.user_business_e_point_id"
                  validate-stock
                  validate-emission-point
                />
                <section class="aditional-documents mt-4">
                  <b-row class="invoice-bottom-row">
                    <b-col
                      xs="12"
                      sm="12"
                      md="4"
                      offset-md="0"
                      order="1"
                      order-md="2"
                      class="mb-3 mb-md-0 ml-md-auto"
                    >
                      <DocumentCalculator
                        :setProducts="formDocument.products"
                        @onChangeSwitchDiscount="onChangeSwitchDiscount"
                        @onTotalChange="onCalcTotalChange"
                      />
                    </b-col>
                    <b-col xs="12" sm="12" md="6" order="2" order-md="1">
                      <InvoicePaymentConditionsComponent
                        :invoiceTotal="invoiceTotal"
                        :initialMethodPayment="formDocument.method_payment"
                        @onChange="onPaymentConditionsChange"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col xs="12" sm="12" md="6">
                      <DocumentAdditionalInfoComponent
                        @onAdditionals="onAdditionals"
                      />
                    </b-col>
                  </b-row>
                </section>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-form>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import InputDatePickerComponent from "../../../../components/InputDatePicker";
import SelectBusinessComponent from "../../../../components/SelectBusinessV2";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import TableInputProducts from "../../../components/TableInputProducts";
import SelectSriFormsPaymentsComponent from "../../../../components/SelectSriFormsPayments";
import DocumentAdditionalInfoComponent from "../../../components/DocumentAdditionalInfo";
import DocumentCalculator from "../../../components/DocumentCalculator";
import moment from "moment";
import invoiceService from "../services/invoiceService";
import projectService from "../../projects/services/projectService";
import Validate from "@/assets/validate";
import InvoicePaymentConditionsComponent from "../components/InvoicePaymentConditions";

const DATE_AT = moment().format("YYYY-MM-DD");

export default {
  name: "InvoiceAddPage",
  data: () => ({
    products: [],
    product_select: "",
    projects: [],
    selectedClientId: null,
    formDocument: {
      user_business_id: null,
      user_business_client_id: "",
      user_business_e_point_id: null,
      sri_forms_payment_id: 7,
      email: "",
      emission_date: DATE_AT,
      discount: 0,
      discount_type: "",
      products: [],
      additional_extras: [],
      method_payment: 1,
      limit_credit: "",
      limit_credit_at: "",
      observation_advance: "",
      reminder_sequence_id: null,
      enable_reminders: false,
      enable_installments: false,
      installments: [],
      project_id: null
    },
    rules: {
      user_business_client_id: [Validate.rules.required("change")],
      user_business_e_point_id: [Validate.rules.required("change")],
      sri_forms_payment_id: [Validate.rules.required("change")],
      emission_date: [Validate.rules.required()],
      email: [Validate.rules.required()]
    },
    invoiceTotal: 0
  }),
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    hasProducts() {
      return this.formDocument.products.length > 0;
    },
    filteredProjects() {
      return this.projects;
    }
  },
  methods: {
    handleSaveClick() {
      this.$refs.formDocument.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            const payload = {
              ...this.formDocument,
              products: this.formDocument.products.map(p => ({
                ...p,
                product_code: p.code
              }))
            };
            let response = await invoiceService
              .addInvoices(payload)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            if (response.data.success) {
              const { id: invoiceId } = response.data.data;
              // Guardar cuotas si están habilitadas
              if (
                this.formDocument.enable_installments &&
                this.formDocument.installments.length
              ) {
                await invoiceService
                  .syncInstallments(invoiceId, this.formDocument.installments)
                  .catch(() => {});
              }
              this.goRouter("sales.invoices.view", {
                id: invoiceId
              });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    onChangeDatePicker({ date }) {
      this.formDocument.emission_date = date;
    },
    onChangeSelectBusiness({ client }) {
      const { email, id } = client;
      this.formDocument.email = email;
      this.formDocument.user_business_client_id = id;
      this.selectedClientId = id;
      // Reset project if it doesn't match the new client
      const currentProject = this.projects.find(
        p => p.id === this.formDocument.project_id
      );
      if (
        currentProject &&
        currentProject.client &&
        currentProject.client.id !== id
      ) {
        this.formDocument.project_id = null;
      }
    },
    onChangeSelectEmissionPoints({ emissionPointId }) {
      this.formDocument.user_business_e_point_id = emissionPointId;
    },
    onToogleProducts({ products }) {
      this.formDocument.products = [...products];
    },
    onChangeSwitchDiscount({ discount, type }) {
      this.formDocument.discount = discount;
      this.formDocument.discount_type = type;
    },
    onChangeSriFormsPaymentsSelect({ sriFormsPaymentsSelect }) {
      this.formDocument.sri_forms_payment_id = sriFormsPaymentsSelect;
    },
    onAdditionals({ additionals }) {
      this.formDocument.additional_extras = additionals;
    },
    onPaymentConditionsChange(payload) {
      Object.assign(this.formDocument, payload);
    },
    onCalcTotalChange(total) {
      this.invoiceTotal = total;
    },
    async loadProjects() {
      try {
        const res = await projectService.getProjects({
          skipErrorNotification: true
        });
        if (res.data.success) this.projects = res.data.data || [];
      } catch (e) {
        /* silent — projects are optional */
      }
    }
  },
  components: {
    ButtonPrimaryComponent,
    TopBarTitleComponent,
    InputDatePickerComponent,
    SelectBusinessComponent,
    SelectEmissionPointsComponent,
    TableInputProducts,
    SelectSriFormsPaymentsComponent,
    DocumentAdditionalInfoComponent,
    DocumentCalculator,
    InvoicePaymentConditionsComponent
  },
  mounted() {
    this.formDocument.user_business_id = this.getUser.user_business.id;
    this.loadProjects();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .document-additional-info {
  background: #fff;
  border: 1px solid #e4eaf6;
  border-radius: 8px;
  padding: 16px 20px;
  h5 {
    font-size: 14px;
    color: #31355c;
    font-weight: 600;
    &::before {
      content: "\e6e1 ";
      font-family: "element-icons";
      color: #3fdbbf;
      margin-right: 6px;
    }
  }
}
</style>
